import MuiLink from '@mui/material/Link'
import { styled } from '@mui/material/styles'

export const Wrapper = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end',
}))

export const Link = styled(MuiLink)(({ theme }) => ({
  marginTop: theme.spacing(4),
}))
